import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '400px',
};



function MyGoogleMap({lat, long}) {

    const center = {
        lat: parseFloat(lat), // Latitude de Paris (par exemple)
        lng: parseFloat(long),  // Longitude de Paris
    };
    
    console.log(center)


  return (
    <LoadScript googleMapsApiKey={process.env.GOOGLE_MAP} >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        streetView={true}
      >
        {/* Optionnel: Ajouter un marqueur sur la carte */}
        <Marker position={center} visible={true}/>
      </GoogleMap>
    </LoadScript>
  );
}

export default React.memo(MyGoogleMap);
